
import React, { Component } from 'react'
import { connect } from 'react-redux'

import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'



import FlatButton from 'material-ui/FlatButton'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Colors from 'material-ui/styles/colors'

import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'

import AttachmentCard from 'components/Attachments/AttachmentCard'
import { managerAvatar } from 'selectors/attachments'

let select = (state, props) => ({
	avatar: managerAvatar(state, props.id)
})

export class ManagerCard extends Component {
	render() {
		console.log(this.props.avatar);
	return(
		(!this.props.manager)? <div></div>
		:<Link
			className="ent-card repairman-card"
			to={`/manager/managers/${this.props.id}`}
		>
			<ListItem
				key={`task-${this.props.id}`}
				style={{
					height: "86px"
				  , backgroundColor: (this.props.lastInteracted == this.props.id)? "#E8E8E8": "#FFF"
				  , overflow: 'hidden'
				  , paddingLeft:"0"
				  , marginLeft: (typeof global.md.phone() != 'string')?"0":undefined
				  , borderBottom: "1px solid #e1e3e2"
				  , margin: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0px 00px 0px 0px" : "0pt 0pt 0pt 0"
				  , textOverflow: "ellipsis"
				}}
				className="list-hover"
				onClick={(evt)=> {
					this.props.openPanel({type: 'tenant', id: this.props.id})
				}}
			>
			{
				(this.props.avatar)?
						<AttachmentCard
							attachmentID={this.props.avatar._id}
							avatar={true}
							avatarStyle={{
								width: "32px"
							  , height: "32px"
							  , overflow: "hidden"
							  , borderRadius: "100%"
							  , display: "inline-block"
							  , float: "left"
							  , margin: "0 26px 0 13px"
							}}
						/>
					:<div>
						<img
							src={"/manager/static/img/svg-icon/managers_green.svg"}
							className="left-navigation-icons"
							style={{
								width: "24px"
							  , height: "24px"
							  , marginTop: "10px"
							  , margin: '16px'
							  , float: "left"
							  , marginRight: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"20px":"32px"
							}}
						/>
					</div>
			}
			<span
				style={{
					position: "relative"
				  , bottom: -5
				  , fontSize: 14
				  , fontWeight: "bold"
				}}
			>
				{this.props.manager.name}
			</span>
			<p style={{fontSize: "12px", position: "relative", paddingLeft: "0px", top: "3px", color: "#000000"}}>
				Phone: {(this.props.manager.cellNumber)? this.props.manager.cellNumber : 'No number'}
			</p>

			</ListItem>
		</Link>
	)
	}
}
export default connect(select)(ManagerCard)



// WEBPACK FOOTER //
// ./src/routes/manager/managers/ManagerCard.js